import '../css/from.css';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import Layout from '../components/layout/Layout';
import { useDispatch, useSelector } from 'react-redux';
import { Form, InputNumber, Button, Row, Col, Typography, Card, Skeleton } from 'antd';
import { UserOutlined, GlobalOutlined, CalendarOutlined, TrophyOutlined, SaveOutlined } from '@ant-design/icons';
import { fetchStatsContent, updateStatsContent, selectStatsData, selectStatsStatus, selectStatsSubmitStatus, resetSubmitStatus } from '../redux/statsSlice';

const ChampionshipStatsPage = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const content = useSelector(selectStatsData);
  const status = useSelector(selectStatsStatus);
  const submitStatus = useSelector(selectStatsSubmitStatus);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchStatsContent());
    }
  }, [status, dispatch]);

  useEffect(() => {
    if (content) {
      form.setFieldsValue({
        competitors: content.competitors || 0,
        countries: content.countries || 0,
        events: content.events || 0,
        champions: content.champions || 0,
      });
    }
  }, [content, form]);

  const onFinish = async (values) => {
    try {
      await dispatch(updateStatsContent(values)).unwrap();
      toast.success('Championship statistics updated');
      dispatch(resetSubmitStatus());
    } catch (e) {
      toast.error(`Failed to update stats: ${e.message || e}`);
    }
  };

  if (status === 'loading' && !content) {
    return (
      <Layout title="Championship Statistics">
        <Card style={{ borderRadius: '12px' }}>
          <Skeleton active paragraph={{ rows: 4 }} />
        </Card>
      </Layout>
    );
  }

  return (
    <Layout title="Championship Statistics">
      <div className="about-form-wrapper">
        <div className="form-container">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
          >
            <div className="premium-card card-indigo">
              <div className="card-header-tag">Overview</div>
              <Typography.Text className="section-label">Key Metrics</Typography.Text>
              <Typography.Text className="section-description">Manage the primary statistics displayed on the global championship leaderboard.</Typography.Text>

              <Row gutter={[20, 0]}>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item name="competitors" label="Total Competitors" rules={[{ required: true, message: 'Required' }]}>
                    <InputNumber prefix={<UserOutlined />} min={0} style={{ width: '100%' }} placeholder="0" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item name="countries" label="Participating Countries" rules={[{ required: true, message: 'Required' }]}>
                    <InputNumber prefix={<GlobalOutlined />} min={0} style={{ width: '100%' }} placeholder="0" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item name="events" label="Global Events" rules={[{ required: true, message: 'Required' }]}>
                    <InputNumber prefix={<CalendarOutlined />} min={0} style={{ width: '100%' }} placeholder="0" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item name="champions" label="Championship Titles" rules={[{ required: true, message: 'Required' }]}>
                    <InputNumber prefix={<TrophyOutlined />} min={0} style={{ width: '100%' }} placeholder="0" />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="sticky-action-footer">
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={submitStatus === 'loading'}
                icon={<SaveOutlined />}
                style={{ borderRadius: '8px', height: '44px' }}
              >
                Save Statistics
              </Button>
            </div>

            <div className="form-footer-spacer" />
          </Form>
        </div>
      </div>
    </Layout>
  );
};

export default ChampionshipStatsPage;